import './StatisticsContainer.css';
import React from 'react';
import { get, getDictionaryItem } from '../../utils';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { Text, Placeholder, RichText } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import RouterLink from '../atoms/RouterLink';
export var StatisticsContainer = function StatisticsContainer(_ref) {
  var fields = _ref.fields,
    rendering = _ref.rendering,
    children = _ref.children,
    params = _ref.params;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var isDetSite = get(params, 'RenderingStyle') === 'DDA';
  var title = get(fields, 'data.item.title.jss');
  var readMoreLink = get(fields, 'data.item.readMoreLink.jss.value.href');
  var dictionary = get(fields, 'data.dictionary');
  var heading = get(fields, 'data.item.heading.jss.value');
  var description = get(fields, 'data.item.description');
  var ctaLeftIcon = get(fields, 'data.item.ctaLeftIcon.targetItem.svg.jss.value');
  var ctaRightIcon = get(fields, 'data.item.ctaRightIcon.targetItem.svg.jss.value');
  if (!fields) {
    console.warn('StatisticsContainer component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [StatisticsContainer component is empty: please provide data source]");
    }
    return null;
  }

  // Those tweaks with length and  slice arguments are for three cases:
  //  - show  single wide element and not  extra markup
  //  - show two elements as half width blocks
  //  - show first element wide and all other as silder

  var renderPlaceholder = function renderPlaceholder() {
    if (!rendering) {
      console.error("The 'rendering' prop is required.");
      alert("The 'rendering' prop is required.");
      return /*#__PURE__*/React.createElement("div", null, "Error: 'rendering' prop is missing.");
    } else {
      return /*#__PURE__*/React.createElement(Placeholder, {
        name: "statistics-container",
        rendering: rendering
      });
    }
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter'],
    isDetSite: isDetSite
  }, /*#__PURE__*/React.createElement("div", {
    className: "row justify-content-md-center-x statistics-container__row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-12 bgn__col statistics-container__title-btn-row justify-content-center"
  }, /*#__PURE__*/React.createElement(Text, {
    className: "bgn__main-title",
    field: title,
    tag: "h2"
  }), heading && /*#__PURE__*/React.createElement("h3", {
    className: "h3 bgn__title"
  }, heading), description && /*#__PURE__*/React.createElement(RichText, {
    tag: "div",
    className: "bgn__desc",
    field: description.jss
  })), process.env.STORYBOOK_MODE ? children : renderPlaceholder(), /*#__PURE__*/React.createElement("div", {
    className: "col-md-12 bgn__col statistics-container__title-btn-row justify-content-center"
  }, readMoreLink && /*#__PURE__*/React.createElement(RouterLink, {
    className: "statistics-container__cta bgn__link-last btn ".concat(isDetSite ? 'btn-primary' : 'btn-secondary'),
    href: readMoreLink
  }, ctaLeftIcon ? /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: ctaLeftIcon
    },
    className: "ctaLeftIcon"
  }) : /*#__PURE__*/React.createElement(React.Fragment, null), /*#__PURE__*/React.createElement("span", {
    className: "btn-secondary__text bgn__link-text"
  }, " ", getDictionaryItem(dictionary, 'readmore')), ctaRightIcon ? /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: ctaRightIcon
    },
    className: "ctaRightIcon"
  }) : /*#__PURE__*/React.createElement(React.Fragment, null)))));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    anchorUrlParameter = _ref2.anchorUrlParameter,
    isDetSite = _ref2.isDetSite;
  var commonStyles = isDetSite ? "cdwgmva" : "crs6c15";
  var ltrStyles = "lckzftc";
  var rtlStyles = "rgmrszd";
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
export default StatisticsContainer;